

export const MOTILAL_OSWAL_AMC = '127';

const MOTILAL_WEEKLY_FREQUENCY = 'Weekly';
const MOTILAL_FORTNIGHTLY_FREQUENCY = 'Fortnightly';

const SUNDAY = 0;
const SATURDAY = 6;

export const MOTILAL_FORTNIGHTLY_END_DATES: Record<number, number[]> = {
    1: [1, 14],
    7: [7, 21],
    21: [7, 21],
    14: [14, 28],
    28: [14, 28],
};

export const MOTILAL_WEEKLY_DAYS: { value: number; label: string }[] = [
    { value: 1, label: 'Monday' },
    { value: 2, label: 'Tuesday' },
    { value: 3, label: 'Wednesday' },
    { value: 4, label: 'Thursday' },
    { value: 5, label: 'Friday' },
];

export const isMotilalOswal = (amc?: string | null) => String(amc) === MOTILAL_OSWAL_AMC;

export const isMotilalWeekly = (amc: string | undefined, frequency: string | undefined) =>
    isMotilalOswal(amc) && frequency === MOTILAL_WEEKLY_FREQUENCY;

export const isMotilalFortnightly = (amc: string | undefined, frequency: string | undefined) =>
    isMotilalOswal(amc) && frequency === MOTILAL_FORTNIGHTLY_FREQUENCY;

const isWeekend = (day: number) => day === SUNDAY || day === SATURDAY;


export const isAllowedMotilalWeeklyDay = (weekday: number) => weekday >= 1 && weekday <= 5;

export const getNextWeekdayOnOrAfter = (from: Date, weekday: number): Date | null => {
    if (!isAllowedMotilalWeeklyDay(weekday)) return null;
    const result = new Date(from);
    while (result.getDay() !== weekday || isWeekend(result.getDay())) {
        result.setDate(result.getDate() + 1);
    }
    return result;
};


export const getMotilalFortnightlyEndDate = (
    startDate: Date,
    numInstallments: number,
): Date | null => {
    const startDay = startDate.getDate();
    const allowedPair = MOTILAL_FORTNIGHTLY_END_DATES[startDay];
    const safeInstallments = Math.max(Math.trunc(Number(numInstallments)) || 1, 1);
    if (!allowedPair) return null;
    const [low, high] = [...allowedPair].sort((a, b) => a - b);
    const startIsLow = startDay === low;
    let monthsToAdd: number;
    let targetDay: number;
    if (startIsLow) {
        monthsToAdd = Math.floor((safeInstallments - 1) / 2);
        targetDay = safeInstallments % 2 === 1 ? low : high;
    } else {
        if (safeInstallments % 2 === 1) {
            monthsToAdd = Math.floor((safeInstallments - 1) / 2);
            targetDay = high;
        } else {
            monthsToAdd = Math.floor(safeInstallments / 2);
            targetDay = low;
        }
    }
    const endDate = new Date(startDate);
    endDate.setDate(1);
    endDate.setMonth(endDate.getMonth() + monthsToAdd);
    endDate.setDate(targetDay);
    return endDate;
};


export const getMotilalFortnightlyInstallmentDiff = (
    startDate: Date,
    endDate: Date,
): number => {
    const startDay = startDate.getDate();
    const allowedPair = MOTILAL_FORTNIGHTLY_END_DATES[startDay];
    if (!allowedPair) return NaN;
    const [low, high] = [...allowedPair].sort((a, b) => a - b);
    const startIsLow = startDay === low;
    const endDay = endDate.getDate();
    const monthsDiff =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());
    if (startIsLow) {
        if (endDay === low) return monthsDiff * 2;
        if (endDay === high) return monthsDiff * 2 + 1;
        return NaN;
    }
    if (endDay === high) return monthsDiff * 2;
    if (endDay === low) return monthsDiff * 2 - 1;
    return NaN;
};
